module.exports = __webpack_public_path__ + "static/media/virtual4.24681ef2.png";